import { PreDraftContractController } from '@features/pre-draft-contract';
import withMenuLayout from '@root/src/layout/withMenuLayout';

export const UserPreDraftContractPage = withMenuLayout(PreDraftContractController);
